import { parseAsArrayOf } from 'nuqs';

import { useCreditNoteFilters } from '~/api/creditNotes';
import { ColumnIds } from '~/constants/table';
import { SearchParamKeys } from '~/constants/url';
import { includes } from '~/utils/arrays';
import { createTableSearchParams, parseAsIntegerWithValidation, parseAsStringWithValidation } from '~/utils/nuqs';

export const {
  useColumnFilters: useCreditNotesTableColumnFilters,
  useGlobalFilter: useCreditNotesTableGlobalFilter,
  usePaginationState: useCreditNotesTablePaginationState,
  useSorting: useCreditNotesTableSorting,
} = createTableSearchParams({
  columnFilters: {
    [SearchParamKeys.columnFilterClient]: ColumnIds.creditNotesClient,
    [SearchParamKeys.columnFilterBrand]: ColumnIds.creditNotesBrand,
    [SearchParamKeys.columnFilterYears]: ColumnIds.creditNotesDocYear,
    [SearchParamKeys.columnFilterQuarters]: ColumnIds.creditNotesDocQuarter,
    [SearchParamKeys.columnFilterStatuses]: ColumnIds.creditNotesStatus,
  },
  defaultSorting: { id: ColumnIds.creditNotesDocDate, desc: true },
  sortableColumnIds: [
    ColumnIds.creditNotesDescription,
    ColumnIds.creditNotesClient,
    ColumnIds.creditNotesDocDate,
    ColumnIds.creditNotesReason,
    ColumnIds.creditNotesStatus,
    ColumnIds.creditNotesTotal,
  ],
  sortingIdPrefix: 'credit_notes_',
  useColumnFilterParsers: () => {
    const { data: filters } = useCreditNoteFilters();

    return {
      [SearchParamKeys.columnFilterClient]: parseAsIntegerWithValidation((value) => includes(filters.clientIds, value)),
      [SearchParamKeys.columnFilterBrand]: parseAsIntegerWithValidation((value) => includes(filters.brandIds, value)),
      [SearchParamKeys.columnFilterYears]: parseAsArrayOf(
        parseAsIntegerWithValidation((value) => includes(filters.years, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterQuarters]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.quarters, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterStatuses]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.statuses, value)),
      ).withDefault([]),
    };
  },
});
